<template>
  <div class="btb-loader p-3">
    <slot>
      <div class="btb-loading">
        <span class="font-italic">
          {{ text }}
        </span>
        <span class="btb-loading-dot" v-for="(dot, idx) in dots" :key="dot" :style="`--animation-delay: ${ idx }`">.</span>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    dots: {
      type: Number,
      default: () => 3
    }
  },
  computed: {
    text () {
      return `Finding ${ this.title }`
    }
  }
}
// Having had the success you've had, how do you stay focused on your business as opposed to other pursuits? Have you found your vision has changed
</script>

<style scoped>

.btb-loader {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.btb-loading-dot {
  display: inline-block;
  animation: jump 1s ease infinite;
  animation-delay: calc(0.25s * var(--animation-delay));
}

@keyframes jump {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-0.25rem);
  }
  50% {
    transform: translateY(0);
  }
}
</style>

